import { styled } from '@mui/material/styles'

export const CustomBold = styled('span')`
    color: ${props => props.theme.palette.grey[700]};
    font-weight: 500;
`

export default CustomBold
